import { motion } from "framer-motion";
import { INDUSTRIES } from "@/lib/constants";
import { SectionHeader } from "@/components/Services";
import { CheckCircle2 } from "lucide-react";

export const Industries = () => {
  return (
    <section id="industries" data-testid="industries-section" className="py-24 relative">
      <div className="section-divider mb-24 max-w-7xl mx-auto" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <SectionHeader eyebrow="Industries" title="Trusted across every kind of Indian business" desc="From neighbourhood clinics to premium jewellery brands — our playbooks are built for Indian buyers and Indian markets." />
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-3 sm:gap-4">
          {INDUSTRIES.map((ind, i) => (
            <motion.div
              key={ind}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: i * 0.03, duration: 0.45 }}
              data-testid={`industry-${i}`}
              className="flex items-center gap-2.5 px-4 py-3.5 rounded-xl bg-white/[0.03] border border-white/10 hover:bg-[#D4AF37]/[0.08] hover:border-[#D4AF37]/40 transition-all group"
            >
              <CheckCircle2 size={14} className="text-[#D4AF37] shrink-0" />
              <span className="text-sm text-white/85 group-hover:text-white transition-colors">{ind}</span>
            </motion.div>
          ))}
        </div>
        <div className="mt-8 text-center text-sm text-white/50">…and many more industries across India.</div>
      </div>
    </section>
  );
};
